// extracted by mini-css-extract-plugin
module.exports = {"home":"home-dpwl_home__mR0m3","fullscreenIframe":"home-dpwl_fullscreenIframe__9b1Vz"};